import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_PERIODOS_ACADEMICOS,
  ALL_PERIODOS_ACADEMICOS,
  LOADING_ALL_PERIODOS_ACADEMICOS,
} from './PeriodosAcademicosReducer';
import {
  allPeriodosAcademicosService,
  deletePeriodosAcademicosService,
  onePeriodosAcademicosService,
  savePeriodosAcademicosService,
} from './PeriodosAcademicosService';

export const allPeriodosAcademicosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_PERIODOS_ACADEMICOS, payload: true });
    const res = await allPeriodosAcademicosService(params);
    dispatch({ type: ALL_PERIODOS_ACADEMICOS, payload: res.data });
    dispatch({ type: LOADING_ALL_PERIODOS_ACADEMICOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_PERIODOS_ACADEMICOS, payload: false });
    tryCatchHelper(e);
  }
};

export const savePeriodosAcademicosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await savePeriodosAcademicosService(id, data);
    notify(res.data.message);
    await allPeriodosAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPeriodosAcademicosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PERIODOS_ACADEMICOS, payload: data });
};

export const onePeriodosAcademicosAction = async (dispatch, id) => {
  try {
    const res = await onePeriodosAcademicosService(id);
    await setActivoPeriodosAcademicosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deletePeriodosAcademicosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deletePeriodosAcademicosService(id);
    await setActivoPeriodosAcademicosAction(dispatch, null);
    notify(res.data.message);
    await allPeriodosAcademicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
